export default defineNuxtRouteMiddleware(async (to) => {
  // NOTE: disable authentication when MockFlow is active
  if (useRuntimeConfig().public.mockFlow.active) {
    return
  }

  const { loggedIn, refreshSession } = useAuth()

  // This is needed or else loggedIn might be stale
  await refreshSession()

  // redirect the user to the login screen if they're not authenticated
  if (!loggedIn.value) {
    console.debug('User is not authenticated, redirecting to login')

    return navigateTo(useLoginRedirect().buildLoginUrl(to.fullPath))
  }
})
